<template>
  <!-- 系统人员管理 -->
  <div class="systemPerson">
    <HeadTitle :url="url"></HeadTitle>
    <AllSystem></AllSystem>
  </div>
</template>
<script>
import HeadTitle from "../../components/HeadTitle";
import AllSystem from "./components/AllSystem";
export default {
  components: {
    HeadTitle,
    AllSystem,
  },
  name: "SystemPerson",
  data() {
    return {
      url:"/",
    };
  },
};
</script>